import axios from 'axios'
import {config} from '../Config/config'

const rencana_kedatanganService = {
    getAll : () => {
        const result = axios.get(config.apiUrl + '/rencana_kedatangan')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getAppoinment : () => {
        const result = axios.get(config.apiUrl + '/appoinment_done')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getById : (id) => {
        const result = axios.get(config.apiUrl + '/rencana_kedatanganById/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getByFaskesId : (id) => {
        const result = axios.get(config.apiUrl + '/treatment_ByFaskesId/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    EditDataRes : (data) => {
        const result = axios.put(config.apiUrl + '/rencana_kedatangan', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    
    addDataRes : (data) => {
        const result = axios.post(config.apiUrl + '/rencana_kedatangan', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    DeleteDataCancel : (id) => {
        console.log(id)
        const result = axios.put(config.apiUrl + '/rencana_kedatanganCancel', id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    PostDataCancel : (data) => {
        const result = axios.post(config.apiUrl + '/rencana_kedatanganCancel', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getAllFilter : (filter) => {
        const result = axios.post(config.apiUrl + '/rencana_kedatanganFilter', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    countData : (filter) => {
        const result = axios.post(config.apiUrl + '/count_rencana', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    cekRencana : (id) => {
        const result = axios.get(config.apiUrl + '/rencana_kedatanganCek/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },
    
    cekDay : (filter) => {
        const result = axios.post(config.apiUrl + '/cek_rencana', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },
}


export default rencana_kedatanganService